"use client";

import { APP_URL } from "@/lib/constants";
import { usePermissionsModalExperiment } from "@/lib/hooks/usePermissionsModalExperiment";
import {
	type AppEventTypes,
	useAppEvents,
	useFbclid,
	wrapUrlWithFbclid,
} from "@jace/insights";
import { Button, type ButtonProps, cn } from "@jace/ui";
import { usePermissionsModal } from "../contexts/permissions-modal-context";

interface CtaButtonProps extends ButtonProps {
	placement: AppEventTypes["signup_click"]["placement"];
}

export function CtaButton({
	placement,
	onClick,
	className,
	...props
}: CtaButtonProps) {
	const { emit } = useAppEvents();
	const fbclid = useFbclid();
	const { showModal } = usePermissionsModalExperiment();
	const { openModal } = usePermissionsModal();

	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		emit({
			type: "signup_click",
			payload: { placement },
		});

		if (showModal) {
			openModal();
		}

		onClick?.(e);
	};

	return (
		<Button
			intent="secondary"
			size="lg"
			asChild={!showModal}
			onClick={handleClick}
			className={cn("px-2 sm:px-6 cursor-pointer", className)}
			{...props}
		>
			{showModal ? (
				<span>Get Started for Free</span>
			) : (
				<a
					href={
						fbclid
							? wrapUrlWithFbclid(`${APP_URL}/signup`, fbclid)
							: `${APP_URL}/signup`
					}
				>
					Get Started for Free
				</a>
			)}
		</Button>
	);
}
